module.exports = __webpack_public_path__ + "img/casino-prag.c9f32f48.jpg";